// Part of settingsPages, split by screen to keep files short; ../settingsPages.ts merges the parts.
// Keys sit directly under settingsPages, in sub-objects whose names no other part uses.
export const en = {
  migrationTransactions: {
    description:
      "Bring the client's invoices, bills, payments, expenses, deposits, transfers and journal entries over from QuickBooks Online as Outss Accounting transactions.",
    connectFirst: 'Connect QuickBooks first',
    connectFirstHint: "Connect the client's QuickBooks Online company on Move from QuickBooks.",
    whatToImport: 'What to import',
    import: 'Import',
    fromConversion: 'From the conversion date {{date}}, on top of the opening balances.',
    postOpeningFirst: 'Post the opening balances on Move from QuickBooks first.',
    everyTransaction:
      'Every transaction from the start date; earlier balances come over as opening balances.',
    from: 'From',
    to: 'To',
    chooseStart: 'Choose the start date.',
    chooseEnd: 'Choose the end date.',
    endBeforeStart: 'The end date is before the start date.',
    estimatesAsQuotes: 'Estimates as quotes',
    allowExisting: 'Import anyway if Ledger already has transactions in the range',
    checking: 'Checking…',
    check: 'Check',
    nothingPosted: 'Nothing is posted until you start the import.',
    by: 'by {{name}}',
    checked: 'checked {{date}}',
    finished: 'finished {{date}}',
    start: 'Start import',
    resume: 'Resume',
    cancelling: 'Cancelling…',
    reading: 'Reading QuickBooks and checking every transaction…',
    phase: {
      reading: 'Reading QuickBooks',
      contacts: 'Adding customers, vendors and products',
      opening: 'Posting opening balances',
      importing: 'Importing transactions',
      verifying: 'Comparing with QuickBooks',
      done: 'Done',
    },
    working: 'Working',
    doneOf: '{{done}} of {{total}}',
    failedCount: '{{n}} failed',
    result:
      '<b>{{imported}}</b> transactions imported, {{skipped}} skipped (voided or zero in QuickBooks).',
    resultFailed:
      '<b>{{imported}}</b> transactions imported, {{skipped}} skipped (voided or zero in QuickBooks), <bad>{{failed}} could not be imported</bad> (see the problems below).',
    seeImported: 'See what was imported',
    cannotStart: 'The import cannot start yet:',
    col: {
      inQuickBooks: 'In QuickBooks',
      toImport: 'To import',
      alreadyImported: 'Already imported',
      problems: 'Problems',
      used: 'Used',
      qbTaxCode: 'QuickBooks tax code',
      on: 'On',
      rate: 'Rate',
      ledgerTaxCode: 'Outss Accounting tax code',
      transaction: 'Transaction',
      what: 'What',
    },
    opening:
      'QuickBooks has balances before {{from}}: {{lines}} trial balance lines come over as opening balances at {{asOf}}, with open invoices ({{receivable}}) and unpaid bills ({{payable}}).',
    mappingSummary:
      'Mapping: {{accounts}} accounts, {{taxCodes}} tax codes, {{contacts}} customers and vendors and {{items}} products to add',
    accountFor: 'Ledger account for {{name}}',
    taxCodeForSales: 'Ledger tax code for {{name}} on sales',
    taxCodeForPurchases: 'Ledger tax code for {{name}} on purchases',
    notMapped: 'Not mapped',
    sales: 'Sales',
    purchases: 'Purchases',
    untilDate: ' (to {{date}})',
    contactKind: { customer: 'customer', vendor: 'vendor' },
    addedOnStart:
      'Added when the import starts: {{list}}. Customers, vendors and products with the same name in Outss Accounting are used as they are.',
    listSeparator: ', ',
    mappingSaved: 'Mapping saved; checking again',
    saveMapping: 'Save mapping and check again',
    resolution: {
      imported: 'Imported later',
      applied: 'Payment applied',
      reviewed: 'Reviewed',
    },
    problems_one: '{{count}} problem',
    problems_other: '{{count}} problems',
    problemsOpen_one: '{{count}} problem ({{open}} open)',
    problemsOpen_other: '{{count}} problems ({{open}} open)',
    warnings_one: '{{count}} warning',
    warnings_other: '{{count}} warnings',
    warningsOpen_one: '{{count}} warning ({{open}} open)',
    warningsOpen_other: '{{count}} warnings ({{open}} open)',
    issuesSummary: 'Every problem and note: {{problems}}, {{warnings}}',
    loadingComparison: 'Loading the comparison…',
    compared: 'Compared with QuickBooks',
    differences_one: '{{count}} difference',
    differences_other: '{{count}} differences',
    noDifferences: 'No differences',
    readingQuickBooks: 'Reading QuickBooks…',
    readAgain: 'Read QuickBooks again',
    reportAt: '{{title}} at {{date}}',
    agrees: 'agrees',
  },
};

export const ar = {
  migrationTransactions: {
    description:
      'انقل فواتير العميل وفواتير الموردين والمدفوعات والمصروفات والإيداعات والتحويلات وقيود اليومية من QuickBooks Online إلى معاملات في Outss Accounting.',
    connectFirst: 'اربط QuickBooks أولاً',
    connectFirstHint: 'اربط شركة العميل في QuickBooks Online من صفحة الانتقال من QuickBooks.',
    whatToImport: 'ما يتم استيراده',
    import: 'الاستيراد',
    fromConversion: 'من تاريخ التحويل {{date}}، إضافةً إلى الأرصدة الافتتاحية.',
    postOpeningFirst: 'رحّل الأرصدة الافتتاحية من صفحة الانتقال من QuickBooks أولاً.',
    everyTransaction: 'كل المعاملات من تاريخ البدء؛ أما الأرصدة السابقة فتُنقل كأرصدة افتتاحية.',
    from: 'من',
    to: 'إلى',
    chooseStart: 'اختر تاريخ البدء.',
    chooseEnd: 'اختر تاريخ الانتهاء.',
    endBeforeStart: 'تاريخ الانتهاء يسبق تاريخ البدء.',
    estimatesAsQuotes: 'التقديرات كعروض أسعار',
    allowExisting: 'الاستيراد على أي حال إذا كانت في الدفاتر معاملات ضمن هذه الفترة',
    checking: 'جارٍ الفحص…',
    check: 'فحص',
    nothingPosted: 'لا يُرحَّل أي شيء حتى تبدأ الاستيراد.',
    by: 'بواسطة {{name}}',
    checked: 'تم الفحص {{date}}',
    finished: 'انتهى {{date}}',
    start: 'بدء الاستيراد',
    resume: 'استئناف',
    cancelling: 'جارٍ الإلغاء…',
    reading: 'جارٍ قراءة QuickBooks وفحص كل معاملة…',
    phase: {
      reading: 'جارٍ قراءة QuickBooks',
      contacts: 'جارٍ إضافة العملاء والموردين والمنتجات',
      opening: 'جارٍ ترحيل الأرصدة الافتتاحية',
      importing: 'جارٍ استيراد المعاملات',
      verifying: 'جارٍ المقارنة مع QuickBooks',
      done: 'تم',
    },
    working: 'قيد التنفيذ',
    doneOf: '{{done}} من {{total}}',
    failedCount: 'فشل {{n}}',
    result:
      'تم استيراد <b>{{imported}}</b> معاملة، وتم تخطي {{skipped}} (ملغاة أو صفرية في QuickBooks).',
    resultFailed:
      'تم استيراد <b>{{imported}}</b> معاملة، وتم تخطي {{skipped}} (ملغاة أو صفرية في QuickBooks)، و<bad>تعذّر استيراد {{failed}}</bad> (راجع المشكلات أدناه).',
    seeImported: 'عرض ما تم استيراده',
    cannotStart: 'لا يمكن بدء الاستيراد بعد:',
    col: {
      inQuickBooks: 'في QuickBooks',
      toImport: 'للاستيراد',
      alreadyImported: 'مستوردة مسبقًا',
      problems: 'المشكلات',
      used: 'مستخدم',
      qbTaxCode: 'رمز الضريبة في QuickBooks',
      on: 'على',
      rate: 'النسبة',
      ledgerTaxCode: 'رمز الضريبة في Outss Accounting',
      transaction: 'المعاملة',
      what: 'التفاصيل',
    },
    opening:
      'في QuickBooks أرصدة قبل {{from}}: تُنقل {{lines}} من أسطر ميزان المراجعة كأرصدة افتتاحية في {{asOf}}، مع الفواتير المفتوحة ({{receivable}}) وفواتير الموردين غير المدفوعة ({{payable}}).',
    mappingSummary:
      'الربط: {{accounts}} حسابات، {{taxCodes}} رموز ضريبية، و{{contacts}} من العملاء والموردين و{{items}} من المنتجات للإضافة',
    accountFor: 'الحساب في الدفاتر لـ {{name}}',
    taxCodeForSales: 'رمز الضريبة في الدفاتر لـ {{name}} على المبيعات',
    taxCodeForPurchases: 'رمز الضريبة في الدفاتر لـ {{name}} على المشتريات',
    notMapped: 'غير مربوط',
    sales: 'المبيعات',
    purchases: 'المشتريات',
    untilDate: ' (حتى {{date}})',
    contactKind: { customer: 'عميل', vendor: 'مورد' },
    addedOnStart:
      'يُضاف عند بدء الاستيراد: {{list}}. العملاء والموردون والمنتجات التي لها الاسم نفسه في Outss Accounting تُستخدم كما هي.',
    listSeparator: '، ',
    mappingSaved: 'تم حفظ الربط؛ جارٍ الفحص مجددًا',
    saveMapping: 'حفظ الربط والفحص مجددًا',
    resolution: {
      imported: 'استُورد لاحقًا',
      applied: 'طُبّقت الدفعة',
      reviewed: 'تمت المراجعة',
    },
    problems_zero: 'لا توجد مشكلات',
    problems_one: 'مشكلة واحدة',
    problems_two: 'مشكلتان',
    problems_few: '{{count}} مشكلات',
    problems_many: '{{count}} مشكلة',
    problems_other: '{{count}} مشكلة',
    problemsOpen_zero: 'لا توجد مشكلات ({{open}} مفتوحة)',
    problemsOpen_one: 'مشكلة واحدة ({{open}} مفتوحة)',
    problemsOpen_two: 'مشكلتان ({{open}} مفتوحة)',
    problemsOpen_few: '{{count}} مشكلات ({{open}} مفتوحة)',
    problemsOpen_many: '{{count}} مشكلة ({{open}} مفتوحة)',
    problemsOpen_other: '{{count}} مشكلة ({{open}} مفتوحة)',
    warnings_zero: 'لا توجد تنبيهات',
    warnings_one: 'تنبيه واحد',
    warnings_two: 'تنبيهان',
    warnings_few: '{{count}} تنبيهات',
    warnings_many: '{{count}} تنبيهًا',
    warnings_other: '{{count}} تنبيه',
    warningsOpen_zero: 'لا توجد تنبيهات ({{open}} مفتوحة)',
    warningsOpen_one: 'تنبيه واحد ({{open}} مفتوح)',
    warningsOpen_two: 'تنبيهان ({{open}} مفتوحة)',
    warningsOpen_few: '{{count}} تنبيهات ({{open}} مفتوحة)',
    warningsOpen_many: '{{count}} تنبيهًا ({{open}} مفتوحة)',
    warningsOpen_other: '{{count}} تنبيه ({{open}} مفتوحة)',
    issuesSummary: 'كل المشكلات والملاحظات: {{problems}}، {{warnings}}',
    loadingComparison: 'جارٍ تحميل المقارنة…',
    compared: 'المقارنة مع QuickBooks',
    differences_zero: 'لا توجد فروقات',
    differences_one: 'فرق واحد',
    differences_two: 'فرقان',
    differences_few: '{{count}} فروقات',
    differences_many: '{{count}} فرقًا',
    differences_other: '{{count}} فرق',
    noDifferences: 'لا توجد فروقات',
    readingQuickBooks: 'جارٍ قراءة QuickBooks…',
    readAgain: 'قراءة QuickBooks مجددًا',
    reportAt: '{{title}} في {{date}}',
    agrees: 'متطابق',
  },
};
